import { Routes } from '@angular/router';
import { AiReceptionistKnowledgeBaseEditorStore } from './ai-receptionist-knowledge-base-editor.store';
import { AiReceptionistSettingsEditorStore } from './ai-receptionist-settings-editor.store';
import { AiReceptionistSettingsComponent } from './ai-receptionist-settings.component';

export const AI_RECEPTIONIST_ROUTES: Routes = [
  {
    path: '',
    component: AiReceptionistSettingsComponent,
    providers: [
      AiReceptionistKnowledgeBaseEditorStore,
      AiReceptionistSettingsEditorStore,
    ],
    children: [
      {
        path: '',
        redirectTo: 'practice-details',
        pathMatch: 'full',
      },
      {
        path: 'practice-details',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-practice-details/ai-receptionist-knowledge-base-practice-details.component'
          ).then(
            (mod) => mod.AiReceptionistKnowledgeBasePracticeDetailsComponent
          ),
      },
      {
        path: 'our-team',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-our-team/ai-receptionist-knowledge-base-our-team.component'
          ).then((mod) => mod.AiReceptionistKnowledgeBaseOurTeamComponent),
      },
      {
        path: 'opening-hours',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-opening-hours/ai-receptionist-knowledge-base-opening-hours.component'
          ).then((mod) => mod.AiReceptionistKnowledgeBaseOpeningHoursComponent),
      },
      {
        path: 'services-treatments',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-services-treatments/ai-receptionist-knowledge-base-services-treatments.component'
          ).then(
            (mod) => mod.AiReceptionistKnowledgeBaseServicesTreatmentsComponent
          ),
      },
      {
        path: 'appointments-policies',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-appointments-policies/ai-receptionist-knowledge-base-appointments-policies.component'
          ).then(
            (mod) =>
              mod.AiReceptionistKnowledgeBaseAppointmentsPoliciesComponent
          ),
      },
      {
        path: 'emergency-additional',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-emergency-additional/ai-receptionist-knowledge-base-emergency-additional.component'
          ).then(
            (mod) => mod.AiReceptionistKnowledgeBaseEmergencyAdditionalComponent
          ),
      },
      {
        path: 'custom-sections',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-custom-sections/ai-receptionist-knowledge-base-custom-sections.component'
          ).then(
            (mod) => mod.AiReceptionistKnowledgeBaseCustomSectionsComponent
          ),
      },
      {
        path: 'common-questions',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-knowledge-base-common-questions/ai-receptionist-knowledge-base-common-questions.component'
          ).then(
            (mod) => mod.AiReceptionistKnowledgeBaseCommonQuestionsComponent
          ),
      },
      {
        path: 'greeting-messages',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-settings-greeting-messages/ai-receptionist-settings-greeting-messages.component'
          ).then((mod) => mod.AiReceptionistSettingsGreetingMessagesComponent),
      },
      {
        path: 'call-handling-routing',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-settings-call-routing/ai-receptionist-settings-call-routing.component'
          ).then((mod) => mod.AiReceptionistSettingsCallRoutingComponent),
      },
      {
        path: 'booking-configuration',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-settings-booking/ai-receptionist-settings-booking.component'
          ).then((mod) => mod.AiReceptionistSettingsBookingComponent),
      },
      {
        path: 'phone-number',
        loadComponent: () =>
          import(
            './sections/ai-receptionist-settings-phone-number/ai-receptionist-settings-phone-number.component'
          ).then((mod) => mod.AiReceptionistSettingsPhoneNumberComponent),
      },
    ],
  },
];
